module.exports = ".bilan-detail table {\n  width: 100%; }\n"